import {
  getInitialFilterState,
  getInitialListingPageState,
} from 'pages/platform/dashboard/payment/listing/initialStates';
import { IListingPagePropsObj, IPaymentFilterObj } from 'pages/platform/dashboard/payment/listing/types';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IConfig {
  openPaymentFilterDropdown: boolean;
  paymentFilterObj: IPaymentFilterObj;
  listingPageProps: IListingPagePropsObj;
}

const initialState: IConfig = {
  openPaymentFilterDropdown: false,
  paymentFilterObj: getInitialFilterState(),
  listingPageProps: getInitialListingPageState(),
};

export const paymentSlice = createSlice({
  name: 'paymentConfig',
  initialState,
  reducers: {
    setOpenPaymentFilterDropdown: (state, action: PayloadAction<boolean>) => {
      state.openPaymentFilterDropdown = action.payload;
    },
    setPaymentFilterObj: (state, action: PayloadAction<IPaymentFilterObj>) => {
      state.paymentFilterObj = action.payload;
    },
    setListingPagePropsObj: (state, action: PayloadAction<IListingPagePropsObj>) => {
      state.listingPageProps = action.payload;
    },
  },
});

export const { setOpenPaymentFilterDropdown, setPaymentFilterObj, setListingPagePropsObj } = paymentSlice.actions;

export default paymentSlice.reducer;
